import { CheckCircle2, Mail, Printer } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const SuccessStep = ({ jobId, queueInfo, customerEmail }) => {
  return (
    <Card className="w-full max-w-md mx-4 text-center border-slate-200 shadow-md" data-testid="success-card">
      <CardHeader className="pb-4">
        <div className="w-16 h-16 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mx-auto mb-3">
          <CheckCircle2 className="w-10 h-10" />
        </div>
        <CardTitle className="font-heading text-2xl text-emerald-800">Payment Successful!</CardTitle>
        <CardDescription className="text-sm text-slate-600">
          Your print job has been created and sent to the kiosk printer.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-5 pt-0">
        <div className="bg-slate-50 p-4 rounded-xl space-y-3 text-left border border-slate-200">
          <div className="flex justify-between items-center border-b border-slate-200/80 pb-2.5">
            <span className="text-xs font-medium text-slate-500 flex items-center gap-1.5">
              <Printer className="w-4 h-4 text-slate-700" /> Job ID
            </span>
            <span className="font-mono text-base font-bold text-slate-900">{jobId || 'IPPL_2627_1'}</span>
          </div>

          {queueInfo?.queue_position !== undefined && (
            <div className="flex justify-between items-center border-b border-slate-200/80 pb-2.5">
              <span className="text-xs font-medium text-slate-500">Queue Position</span>
              <span className="font-semibold text-xs text-slate-800">#{queueInfo.queue_position}</span>
            </div>
          )}

          {customerEmail && (
            <div className="flex justify-between items-center pt-0.5">
              <span className="text-xs font-medium text-slate-500 flex items-center gap-1.5">
                <Mail className="w-4 h-4 text-slate-700" /> Receipt Sent
              </span>
              <span className="text-xs text-slate-700 truncate max-w-[180px]">{customerEmail}</span>
            </div>
          )}
        </div>

        <div className="p-4 bg-emerald-50 text-emerald-900 rounded-xl text-left border border-emerald-200">
          <p className="text-xs text-emerald-900 leading-relaxed font-semibold">
            Next steps: collect your printed documents from the kiosk
          </p>
        </div>

        <Button
          className="w-full bg-[#7d0909] hover:bg-[#5a0606] text-white font-medium shadow-sm py-2.5 text-sm"
          onClick={() => window.location.reload()}
          data-testid="print-another-btn"
        >
          Print Another Document
        </Button>
      </CardContent>
    </Card>
  );
};

export default SuccessStep;
